import { useContext } from 'react';
import { ChatDrawerContext } from 'context/chatDrawer';

const useChatDrawerContext = () => {
  return useContext(ChatDrawerContext);
};

export default useChatDrawerContext;
